import { faTrash } from '@fortawesome/free-solid-svg-icons';
import Button from '../../Common/Button/Button';
import { formatTableName, getTableAbbreviation } from '../../Utils/tableHelpers';
import { TABLE_TYPES } from '../../Utils/constants';

/**
 * Individual Table List Item Component
 */
const TableListItem = ({ 
  table, 
  onClick, 
  onDelete,
  canDelete = false,
  disabled = false 
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick(table);
    }
  };

  const handleDelete = (event) => {
    if (event) {
      event.stopPropagation(); // Prevent triggering table selection
      event.preventDefault(); // Prevent any default behavior
    }
    onDelete(table.id, table.table_name, event);
  };

  const isCustomTable = table._type === TABLE_TYPES.CUSTOM;

  return (
    <li 
      className={`template-list-item ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
    >
      <div className="circle-badge">
        {getTableAbbreviation(table.table_name)}
      </div>
      
      <span className="template-name">
        {formatTableName(table.table_name)}
      </span>
      
      <span 
        className="table-type"
        style={{
          marginLeft: 8, 
          fontSize: '0.85em', 
          color: isCustomTable ? '#007bff' : '#888'
        }}
      >
        {isCustomTable ? 'Custom' : 'Template'}
      </span>
      
      {/* Delete button for custom tables only */}
      {isCustomTable && canDelete && !disabled && (
        <Button
          variant="remove"
          icon={faTrash}
          onClick={handleDelete}
          title={`Delete custom table "${table.table_name}"`}
          className="delete-table-button"
          size="small"
        />
      )}
    </li>
  );
};

export default TableListItem;
